import { Room, getStateCallbacks } from "@colyseus/sdk";
import type { MallState, Npc, Player } from "@mall-mart/shared";
import type { MallScene } from "../world/MallScene.js";

export class StateSync {
  private scene: MallScene;
  private localSessionId: string;
  private onSelfSpawn: ((x: number, y: number, z: number) => void) | undefined;

  constructor(
    scene: MallScene,
    localSessionId: string,
    onSelfSpawn?: (x: number, y: number, z: number) => void
  ) {
    this.scene = scene;
    this.localSessionId = localSessionId;
    this.onSelfSpawn = onSelfSpawn;
  }

  attach(room: Room<MallState>): void {
    const $ = getStateCallbacks(room);

    $(room.state).players.onAdd((player: Player, sessionId: string) => {
      if (sessionId === this.localSessionId) {
        // The server assigns each joiner a scatter-ring spawn; stand the
        // local player exactly where everyone else sees their avatar.
        this.onSelfSpawn?.(player.x, player.y, player.z);
        return;
      }
      this.scene.addRemotePlayer(sessionId, player.x, player.y, player.z);

      $(player).onChange(() => {
        this.scene.updateRemotePlayer(
          sessionId,
          player.x,
          player.y,
          player.z,
          player.rotation
        );
      });
    });

    $(room.state).npcs.onAdd((npc: Npc, id: string) => {
      this.scene.npcs.add(id, npc.appearance, npc.x, npc.y, npc.z);
      $(npc).onChange(() => {
        this.scene.npcs.update(id, npc.x, npc.y, npc.z, npc.rotation, npc.activity, npc.hasBag);
      });
    });

    $(room.state).npcs.onRemove((_npc: Npc, id: string) => {
      this.scene.npcs.remove(id);
    });

    $(room.state).players.onRemove((_player: Player, sessionId: string) => {
      if (sessionId === this.localSessionId) {
        return;
      }
      this.scene.removeRemotePlayer(sessionId);
    });
  }
}
